/**
 * Custom JS for johngarlandtaylor.com
 * Extracted from theme.js.liquid during Impact 4.3.2 → 7.0.1 migration
 */


/* ============================================
   Sort-By Popover Fix on Mobile (≤999px)
   ============================================
   The stock theme hides the desktop (popover) sort on mobile and uses the facet drawer instead. 
   Our (previous dev) customisation forces the desktop-style popover sort to show on mobile — but once the
   popover is reparented to <body>, listbox:change no longer bubbles through facet-sort-by (which handles the event), so nothing happens.
   Here we mostly use code from FacetSortBy._onValueChanged to re-trigger the event and provide the url */

   document.addEventListener('listbox:change', (event) => {
    // if we are on desktop or somehow the facet-sort-by handles the event, return
    if (event.target.closest('facet-sort-by')) return;
  
    // get popover id
    const popover = event.target.closest('[id^="popover-sort-by-"]');
    if (!popover) return;
  
    // get the main-collection section id from the popover id 
    // below is same as in FacetSortBy._onValueChanged in theme.js
    const sectionId = popover.id.replace('popover-sort-by-', '');
    const url = new URL(location.href);
    url.searchParams.set('sort_by', event.detail.value);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.delete('page');
    if (window.themeVariables?.settings.pageType === 'search') {
      url.searchParams.set('type', 'product');
    }
  
    event.target.dispatchEvent(new CustomEvent('facet:update', {
      bubbles: true,
      detail: { url }
    }));
  });

/* ============================================
   Complementary Products Modal - Close on ATC
   ============================================ */

document.addEventListener('variant:add', function () {
  var modal = document.querySelector('.model-people_also_bought_product');
  var body = document.body;
  var getLookItems = document.querySelectorAll('.get-the-look_get-the-look__xPNpc');

  if (modal && modal.classList.contains('show-model')) {
    getLookItems.forEach(function (item) { item.classList.remove('open'); });
    modal.classList.remove('show-model');
    body.classList.remove('overflow-hidden');
  }
});
